<template>
  <v-card
    height="37px"
    style="box-shadow: unset;
            display: flex;
            align-items: center;
            justify-content: center;"
  >
    <v-row no-gutters>
      <v-col class="d-flex align-center" cols="4">
        <v-checkbox
          class="pb-5"
          color="#a6cc39"
          :label="$t('email')"
          v-model="email_flag"
          @change="handleCheckboxChange"
          hide-details
        ></v-checkbox>
      </v-col>

      <v-col class="d-flex align-center flex-row" cols="8">
        <v-radio-group v-model="selectedRadio" class="radio-group">
          <v-row no-gutters class="d-flex align-center flex-row">
            <!-- Thai Language Option -->
            <v-col class="d-flex align-center">
              <v-radio value="thai" class="radio-button"></v-radio>
              <v-card
                width="35px"
                height="22px"
                style="border-radius: 4px; margin-left: 8px"
              >
                <v-img
                  src="@/assets/imgs/ThaiFlag.svg"
                  width="35"
                  height="22"
                ></v-img>
              </v-card>
            </v-col>

            <!-- English Language Option -->
            <v-col class="d-flex align-center" style="margin-left: 16px">
              <v-radio value="eng" class="radio-button"></v-radio>
              <v-card
                width="35px"
                height="22px"
                style="border-radius: 4px; margin-left: 8px"
              >
                <v-img
                  src="@/assets/imgs/UkFlag.svg"
                  width="35"
                  height="22"
                ></v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-radio-group>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    checked_mail: Boolean,
    language: String
  },
  data() {
    return {
      enable_choose: false,
      selectedRadio: "thai"
    };
  },

  computed: {
    email_flag: {
      get() {
        return this.checked_mail;
      },
      set(val) {
        //this.enable_choose = val;
        return val;
      }
    },
    selectedLang() {
      return this.language;
    }
  },

  watch: {
    selectedLang(v) {
      this.selectedRadio = v !== undefined ? v : null;
    },
    selectedRadio(v) {
      this.$emit("update-text", v, this.email_flag);
    }
  },

  methods: {
    handleCheckboxChange(v) {
      // if (v) {
      //   this.selectedRadio = "thai";
      // } else {
      //   this.selectedRadio = null;
      // }
      this.$emit("update-flag", v);
    }
  }
};
</script>

<style scoped>
.radio-group {
  display: flex;
  align-items: center;
}
.radio-button {
  margin-right: 5px;
}
.radio-wrapper {
  position: relative;
  width: 22px;
  height: 22px;
}
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: 0px;
}
</style>
